import * as tslib_1 from "tslib";
import { Value, Record, Form } from '@swim/recon';
import { LngLat } from 'mapbox-gl';
var LngLatForm = (function (_super) {
    tslib_1.__extends(LngLatForm, _super);
    function LngLatForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LngLatForm.prototype, "unit", {
        get: function () {
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    LngLatForm.prototype.mold = function (point) {
        if (point) {
            return Record.empty(2).slot('lng', point.lng).slot('lat', point.lat);
        }
        return Value.Absent;
    };
    LngLatForm.prototype.cast = function (value) {
        var lng = value.get('lng').numberValue();
        var lat = value.get('lat').numberValue();
        if (lng !== undefined && lat !== undefined) {
            return new LngLat(lng, lat);
        }
        return undefined;
    };
    return LngLatForm;
}(Form));
export var Mapbox = {
    LngLatForm: new LngLatForm(),
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwYm94LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibWFwYm94LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQUMsS0FBSyxFQUFHLE1BQU0sRUFBRSxJQUFJLEVBQUMsTUFBTSxhQUFhLENBQUM7QUFDakQsT0FBTyxFQUFDLE1BQU0sRUFBQyxNQUFNLFdBQVcsQ0FBQztBQUVqQztJQUF5QixzQ0FBd0I7SUFBakQ7O0lBb0JBLENBQUM7SUFuQkMsc0JBQUksNEJBQUk7YUFBUjtZQUNFLE1BQU0sQ0FBQyxTQUFTLENBQUM7UUFDbkIsQ0FBQzs7O09BQUE7SUFFRCx5QkFBSSxHQUFKLFVBQUssS0FBeUI7UUFDNUIsRUFBRSxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQztZQUNWLE1BQU0sQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ3ZFLENBQUM7UUFDRCxNQUFNLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQztJQUN0QixDQUFDO0lBRUQseUJBQUksR0FBSixVQUFLLEtBQVk7UUFDZixJQUFNLEdBQUcsR0FBRyxLQUFLLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxDQUFDLFdBQVcsRUFBRSxDQUFDO1FBQzNDLElBQU0sR0FBRyxHQUFHLEtBQUssQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUMsV0FBVyxFQUFFLENBQUM7UUFDM0MsRUFBRSxDQUFDLENBQUMsR0FBRyxLQUFLLFNBQVMsSUFBSSxHQUFHLEtBQUssU0FBUyxDQUFDLENBQUMsQ0FBQztZQUMzQyxNQUFNLENBQUMsSUFBSSxNQUFNLENBQUMsR0FBRyxFQUFFLEdBQUcsQ0FBQyxDQUFDO1FBQzlCLENBQUM7UUFDRCxNQUFNLENBQUMsU0FBUyxDQUFDO0lBQ25CLENBQUM7SUFDSCxpQkFBQztBQUFELENBQUMsQUFwQkQsQ0FBeUIsSUFBSSxHQW9CNUI7QUFFRCxNQUFNLENBQUMsSUFBTSxNQUFNLEdBQUc7SUFDcEIsVUFBVSxFQUFFLElBQUksVUFBVSxFQUE4QjtDQUN6RCxDQUFDIn0=